import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { BackToTop } from '../ui/BackToTop';
import { ArabicFooter } from './ArabicFooter';
import { ArabicHeader } from './ArabicHeader';
interface ArabicLayoutProps {
  children: React.ReactNode;
}
export function ArabicLayout({
  children
}: ArabicLayoutProps) {
  const location = useLocation();
  useEffect(() => {
    const previousDirection = document.documentElement.dir;
    const previousLanguage = document.documentElement.lang;
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
    return () => {
      document.documentElement.dir = previousDirection;
      document.documentElement.lang = previousLanguage;
    };
  }, []);
  useEffect(() => {
    if (!location.hash) return;
    const targetId = decodeURIComponent(location.hash.slice(1));
    const timeout = window.setTimeout(() => {
      document.getElementById(targetId)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 0);
    return () => window.clearTimeout(timeout);
  }, [location.hash, location.pathname]);
  return <div className="arabic-site flex min-h-screen max-w-full flex-col overflow-x-clip" dir="rtl" lang="ar" data-id="element-464" data-mp="3am7ye0qq8sdd">
      <ArabicHeader data-id="element-465" data-mp="35mvcpjbldrcd" />
      <main className="min-w-0 flex-1" data-id="element-466" data-mp="35md3zn7qtknk">{children}</main>
      <ArabicFooter data-id="element-467" data-mp="30ots2tyipjys" />
      <BackToTop position="left" data-id="element-468" data-mp="30pcz3fmmqny1" />
    </div>;
}